<template>
    <div class="">
        <el-upload
            class="upload-demo"
            :action="baseURL+url"
            :show-file-list="false"
            :on-success="addEventOnSuccess"
            :on-error="addEventOnError"
            :headers="headers"
            :on-progress="addOnProgress"
            :before-upload="beforeAvatarUpload"
            :multiple="multiple"
            :limit="999"
        >
            <slot name="content" />
        </el-upload>
    </div>
</template>
<script>
import { baseURL } from '@/api/config'
let loading ;
export default {
    name:'NfUpload',
    props:{
        url:{
            type:String,
            default:''
        },
        // 1是合同 2是照片  
        type:{
            type:String,
            default:'1'
        },
        // 是否允许上传多个
        multiple:{
            type:Boolean,
            default:true
        },
        // 上传成功回调
        addEventUpload:{
            type:[Boolean,Function],
            default:false
        },
        // 文件上传成功的提示文字
        successMsg:{
            type:String,
            default:""
        },
        beforeUpload:{
            type:[Boolean,Function],
            default:false
        }
    },
    data(){
        return {
            headers:{
                'X-TOKEN':window.localStorage.token
            },
            baseURL,
        }
    },
    methods:{
        // 开始上传
        addOnProgress(){
            loading = this.$loading({
                lock: true,
                text: '文件上传中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        // 上传成功
        async addEventOnSuccess(data){
            if(data.code===1){
                this.$$message(this.successMsg?this.successMsg:data.msg)
                if(this.addEventUpload){
                    this.addEventUpload(data);
                }
            }else{
                this.$$message(data.msg,'error')
            }
            loading.close();
        },
        // 上传失败
        addEventOnError(){
            this.$$message('上传失败','error')
            loading.close();
        },
        beforeAvatarUpload(file){
            if(this.beforeUpload){
                return this.beforeUpload(file);
            }
            if(this.type==="1"){
                const isDoc = file.name.includes('.doc') || file.name.includes('.docx');
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isDoc) {
                    this.$message.error('只能上传 doc 或者 docx 格式!');
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error('上传文件大小不能超过 10MB!');
                    return false;
                }
                return isDoc && isLt2M;
            }else if(this.type==='2'){
                const isJPG = file.name.includes('.jpeg') || file.name.includes('.jpg') || file.name.includes('.png');
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isJPG) {
                    this.$message.error('上传图片只能是 JPG 或者 PNG 格式!');
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 10MB!');
                    return false;
                }
                return isJPG && isLt2M;
            }else{
                const isJPG = file.name.includes('.xlsx') ;
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isJPG) {
                    this.$message.error('上传文件只能是 xlsx 格式!');
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error('上传文件大小不能超过 10MB!');
                    return false;
                }
                return isJPG && isLt2M;
            }
           
        }
    }
}
</script>